"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderArrow = exports.getTransform = exports.getTrackWidth = exports.getComponentWrapperWidth = exports.getAttributes = exports.dotRenderer = void 0;
var _react = _interopRequireDefault(require("react"));
var _SpinnerCircular = _interopRequireDefault(require("../Spinner/SpinnerCircular"));
var _constants = require("./constants");
var _range2 = _interopRequireDefault(require("lodash-es/range"));
var _commonHelper = require("../helpers/commonHelper");
var _styles = require("./styles");
// libraries

// components

// helpers

// styles

var renderArrow = exports.renderArrow = function renderArrow(onClick, isDefaultTheme, forceArrowVisible, arrowFromTop, mobileArrowFromTop, mobileArrowHidden, arrowHidden, tabArrowHidden, isPhotoViewer, type) {
  var loading = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : false;
  var arrowClassName = arguments.length > 11 ? arguments[11] : undefined;
  var arrowInsetPadding = arguments.length > 12 ? arguments[12] : undefined;
  var isLeft = type === _constants.LEFT_ARROW;
  return /*#__PURE__*/_react["default"].createElement(_styles.ArrowWrapper, {
    className: arrowClassName,
    "default": isDefaultTheme,
    forceArrowVisible: forceArrowVisible,
    isLeft: isLeft,
    isPhotoViewer: isPhotoViewer,
    arrowHidden: arrowHidden
  }, loading ? /*#__PURE__*/_react["default"].createElement(_styles.SpinnerWrapper, {
    arrowFromTop: arrowFromTop
  }, /*#__PURE__*/_react["default"].createElement(_SpinnerCircular["default"], {
    size: "small",
    color: "#363636"
  })) : /*#__PURE__*/_react["default"].createElement(_styles.Arrow, {
    isLeft: isLeft,
    onClick: onClick,
    onKeyDown: (0, _commonHelper.onKeySelect)(onClick),
    arrowFromTop: arrowFromTop,
    mobileArrowFromTop: mobileArrowFromTop,
    mobileArrowHidden: mobileArrowHidden,
    arrowHidden: arrowHidden,
    tabArrowHidden: tabArrowHidden,
    isPhotoViewer: isPhotoViewer,
    tabIndex: 0,
    role: "button",
    "aria-controls": "carousel-items",
    "aria-label": isLeft ? "Previous Slide" : "Next Slide",
    arrowInsetPadding: arrowInsetPadding
  }));
};
var dotRenderer = exports.dotRenderer = function dotRenderer(isVisible, maxDots, onDotClick, active, insideDots, activeRedDots, scrollableDots, scrollValue, currentWindowFirstIndex, currentWindowLastIndex, newCarouselDots, activeRedDotsAdjusted) {
  return isVisible && (!scrollableDots ? /*#__PURE__*/_react["default"].createElement(_styles.Dots, {
    isInside: insideDots,
    newCarouselDots: newCarouselDots,
    activeRedDotsAdjusted: activeRedDotsAdjusted
  }, (0, _range2["default"])(maxDots).map(function (val, index) {
    return /*#__PURE__*/_react["default"].createElement(_styles.Li, {
      onClick: onDotClick(index),
      key: "dot_".concat(index),
      activeRedDots: activeRedDots
    }, /*#__PURE__*/_react["default"].createElement(_styles.Btn, {
      active: index === active,
      activeRedDots: activeRedDots,
      activeRedDotsAdjusted: activeRedDotsAdjusted
    }));
  })) : /*#__PURE__*/_react["default"].createElement(_styles.DotWrapper, {
    isInside: insideDots
  }, /*#__PURE__*/_react["default"].createElement(_styles.ScrollWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.ScrollBackground, null), /*#__PURE__*/_react["default"].createElement(_styles.ScrollableDots, {
    transitionWidth: scrollValue
  }, (0, _range2["default"])(maxDots).map(function (val, index) {
    var isSmallDot = (index === currentWindowFirstIndex || index === currentWindowLastIndex) && index !== 0 && index !== maxDots - 1;
    return /*#__PURE__*/_react["default"].createElement(_styles.ScrollSection, {
      key: "dot_".concat(index),
      isFirstDot: index === currentWindowFirstIndex,
      isLastDot: index === currentWindowLastIndex || index === maxDots - 1,
      isSmallDot: isSmallDot
    }, /*#__PURE__*/_react["default"].createElement(_styles.ScrollContent, {
      active: index === active,
      isSmallDot: isSmallDot,
      isVisible: index >= currentWindowFirstIndex && index <= currentWindowLastIndex
    }));
  })))));
};
var getTrackWidth = exports.getTrackWidth = function getTrackWidth(props) {
  return "".concat(props.totalWidth * props.componentCount, "px");
};
var getAttributes = exports.getAttributes = function getAttributes(key) {
  return function (props) {
    return props[key];
  };
};
var getComponentWrapperWidth = exports.getComponentWrapperWidth = function getComponentWrapperWidth(props) {
  return (props.totalWidth - props.totalMargin) / props.slidesToShow;
};
var getTransform = exports.getTransform = function getTransform(props) {
  return "translateX(-".concat(props.transitionWidth, "px)");
};